import { render, staticRenderFns } from "./AppRichTextArea.vue?vue&type=template&id=ddb9117c&scoped=true"
import script from "./AppRichTextArea.vue?vue&type=script&lang=js"
export * from "./AppRichTextArea.vue?vue&type=script&lang=js"
import style0 from "./AppRichTextArea.vue?vue&type=style&index=0&id=ddb9117c&prod&scoped=true&lang=css"
import style1 from "./AppRichTextArea.vue?vue&type=style&index=1&id=ddb9117c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb9117c",
  null
  
)

export default component.exports